import { NgModule } from '@angular/core';
import { BaseModule } from '../../../shared/base.module';
import { MeRegisterVerificationRoutesModule } from './register-verification.routes';
import { MeRegisterVerificationComponent } from './register-verification.component';


@NgModule({
    imports: [
        BaseModule
    ],
    declarations: [
        MeRegisterVerificationComponent
    ],
    exports: [
        MeRegisterVerificationComponent
    ]
})
export class MeRegisterVerificationModule { }
